import { render, staticRenderFns } from "./ServerDisplay.vue?vue&type=template&id=2227f56a"
import script from "./ServerDisplay.vue?vue&type=script&lang=js"
export * from "./ServerDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports